import { render, staticRenderFns } from "./NewSchedule.vue?vue&type=template&id=2dbb8491"
import script from "./NewSchedule.vue?vue&type=script&lang=js"
export * from "./NewSchedule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports